import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { OrderPaymentEditPage } from 'src/app/modals/order-payment-edit/order-payment-edit.page';

const routes: Routes = [
  {
    path: '',
    component: OrderPaymentEditPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [OrderPaymentEditPage]
})
export class OrderPaymentEditPageModule {}
